import React, { useRef, useEffect } from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import "./auth.scss";
import adminLogin from "../assets/img/adminLogin.svg";
import routes from "../routes/index";

const backgroundImageUrl =
  "https://firebasestorage.googleapis.com/v0/b/nexteats-staging.appspot.com/o/login_11zon.png?alt=media&token=e0a87137-a0e1-416f-9d82-6f9e50663d73";

const AuthLayout = () => {
  const mainContent = useRef(null);
  const location = useLocation();

  const getRoutes = (routes) =>
    routes.map((prop, key) =>
      prop.layout === "auth" ? (
        <Route
          path={"/" + prop.layout + prop.path}
          component={prop.component}
          key={key}
        />
      ) : null
    );

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  return (
    <div
      className={
        location.pathname !== "/auth/admin-login"
          ? "main-content-auth"
          : "admin-login"
      }
      ref={mainContent}
      style={{
        backgroundImage: `url(${backgroundImageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
      }}
    >
      <div className="h-50 header content pt-5 pb-3 overflow-auto">
        <Container>
          <Row
            className={`justify-content-center ${
              location.pathname === "/auth/admin-login"
                ? "shadow admin-login__row"
                : ""
            }`}
          >
            {location.pathname === "/auth/admin-login" && (
              <Col lg="6" md="7">
                <img src={adminLogin} alt="admin logo" className="login_img" />
              </Col>
            )}
            <Switch>
              {getRoutes(routes)}
              <Redirect from="*" to="/auth/login" />
            </Switch>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default AuthLayout;
